import { AdminTenantLocation } from '@hakimo-ui/hakimo/types';

interface Props {
  location: AdminTenantLocation;
  onEditClick?: () => void;
}

export function LocationInfoCard(props: Props) {
  const { location } = props;

  return (
    <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 overflow-hidden rounded-xl">
      <div className="px-6 py-6">
        <div className="space-y-4">
          <div>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
                  Name
                </dt>
                <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
                  {location.name}
                </dd>
              </div>
              <div>
                <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
                  ID
                </dt>
                <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
                  {location.id}
                </dd>
              </div>
            </div>
          </div>
          <div>
            <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
              Street
            </dt>
            <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
              {location.address || '-'}
            </dd>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div>
              <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
                City
              </dt>
              <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
                {location.city || '-'}
              </dd>
            </div>
            <div>
              <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
                State
              </dt>
              <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
                {location.state || '-'}
              </dd>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div>
              <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
                Country
              </dt>
              <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
                {location.country || '-'}
              </dd>
            </div>
            <div>
              <dt className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
                Time Zone
              </dt>
              <dd className="text-onlight-text-1 dark:text-ondark-text-1 mt-1 text-sm font-semibold">
                {location.timezone || '-'}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationInfoCard;
